import React from 'react';
import { ServerCreate } from '../../types';

interface ServerFormProps {
  formData: ServerCreate;
  setFormData: (formData: ServerCreate) => void;
  handleCreateServer: (e: React.FormEvent) => void;
}

const ServerForm: React.FC<ServerFormProps> = ({ formData, setFormData, handleCreateServer }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Add Server</h2>

      <form onSubmit={handleCreateServer}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Server Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Server URL</label>
          <input
            type="text"
            name="host"
            value={formData.host}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2"
            required
          />
        </div>

      <div className="p-3 bg-blue-50 rounded-md">
        <p className="text-sm text-blue-800">
          <strong>Note:</strong> API credentials are generated automatically. After the source URL is created, the frontend will also mint a
          `BILLING_BACKEND_BEARER_TOKEN` for that URL and show it once so it can be copied into the website env.
        </p>
      </div>
      
      <div className="flex justify-end gap-2">
        <button type="submit" className="btn btn-primary">
          Create Server
        </button>
      </div>
    </form>
  </div>
  );
};

export default ServerForm;
